import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

reportWebVitals();

// Перевіряємо підтримку Service Worker та Push-менеджера
if ('serviceWorker' in navigator && 'PushManager' in window) {
  navigator.serviceWorker
    .register('/sw.js')
    .then(function (registration) {
      console.log('Service Worker зареєстровано:', registration.scope);

      Notification.requestPermission().then(function (permission) {
        if (permission === "granted") {
          console.log("Пуш-повідомлення дозволено");

          registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlB64ToUint8Array('BFNX7rXNnDhQp1bBfnhVjoWL5F_t5zx94qppcsBpSHC5E63_xrt2htUuOSs1J3eexBX0fT-8IuY8wh6XjzIex7Y')
          }).then(function (subscription) {
            console.log('Підписка на пуш: ', subscription);
            // sendSubscriptionToServer(subscription);
          }).catch(function (error) {
            console.error('Не вдалося підписатися на пуш:', error);
          });
        }
      });
    })
    .catch(function (error) {
      console.error('Помилка реєстрації Service Worker:', error);
    });
}

function urlB64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; i++) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}
